<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Meus ingressos'"
    [titleIcon]="'pi pi-ticket'"
    [subtitle]="'Gerencie seus ingressos para eventos futuros, passados ou expirados.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Meus ingressos', icon: 'pi pi-ticket' },
    ]"></app-page-header>

  <div class="container-fluid my-orders-page">
    <div class="mobile-section-toggle">
      <mat-button-toggle-group [(value)]="displayMobile" [hideSingleSelectionIndicator]="true">
        <mat-button-toggle [value]="DISPLAY_MOBILE_OPTIONS_ENUM.FUTURES">FUTUROS</mat-button-toggle>
        <mat-button-toggle [value]="DISPLAY_MOBILE_OPTIONS_ENUM.FINISHED">ENCERRADOS</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    @switch (displayMobile) {
      @case (DISPLAY_MOBILE_OPTIONS_ENUM.FUTURES) {
        <p class="p text-secondary">Ingressos aguardando pagamento ou confirmados para eventos futuros.</p>

        <app-order-list-container [isMobile]="isMobile" [listTimeframe]="DISPLAY_MOBILE_OPTIONS_ENUM.FUTURES" />
      }
      @case (DISPLAY_MOBILE_OPTIONS_ENUM.FINISHED) {
        <p class="p text-secondary">Ingressos de eventos já finalizados ou validados.</p>

        <app-order-list-container [isMobile]="isMobile" [listTimeframe]="DISPLAY_MOBILE_OPTIONS_ENUM.FINISHED" />
      }
      @default {
        <p>Opção não reconhecida</p>
      }
    }
  </div>
</app-layout>
